var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"canvas-wrapper"},[(_vm.isImgLoading)?_c('loader',{staticClass:"canvas-loader"}):_c('canvas',{ref:"canvas",attrs:{"id":"canvas","width":"300","height":"300"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }